import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/partners/ro-footer-1.png")